import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function CategoryNav() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14" aria-label="漫画类型导航">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">按类型找漫画</h2>
          <p className="mt-2 text-sm text-foreground-600">六大类型，总有一款戳中你的心</p>
        </div>
        <Link
          to="/category/reqiu"
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 sm:flex"
        >
          全部书库 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-2xl text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
              <i className={c.icon} aria-hidden="true"></i>
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
                {c.name}
                <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs font-normal text-foreground-500">{c.count}部</span>
              </h3>
              <p className="mt-1 truncate text-sm text-foreground-600">{c.desc}</p>
            </div>
            <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-colors group-hover:text-primary-600" aria-hidden="true"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}